import React from "react";
import ConfigurationMaster from "./ConfigurationMaster";

function ConfigurationRelationship() {
    return (
        <ConfigurationMaster
            type="relationship"
        />
    );
}

export default ConfigurationRelationship;